import { render, staticRenderFns } from "./WebViewScoreboardOverrideSelection.vue?vue&type=template&id=5641d08a&scoped=true"
import script from "./WebViewScoreboardOverrideSelection.vue?vue&type=script&lang=js"
export * from "./WebViewScoreboardOverrideSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641d08a",
  null
  
)

export default component.exports